<template>
  <v-container class="pb-0">
    <v-row class="pa-0 ma-0 bg-EFF6FC" justify="center">
      <v-col cols="12" md="4" lg="4" align-self="center" align="center">
        <!-- <v-avatar
          size="206"
          v-if="
            getQueueDrug.itemData.patient.img !== '' &&
            getQueueDrug.itemData.patient.img !== undefined
          "
          >
          <v-img
            max-height="155"
            max-width="155"
            :src="getQueueDrug.itemData.patient.img"
          />
        </v-avatar> -->
        <v-img
          max-height="155"
          max-width="155"
          :src="require('@/assets/image/Group 427323441.png')"
        ></v-img>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
        align-self="center"
        class="bobyPaddingLeft"
      >
        <v-row class="d-flex pa-0 align-end">
          <v-col cols="12"
            ><span
              class="w-400 text-navy-50 font-18 d-flex justify-end"
              v-if="itemHistory.pickup_location == 'hospital'"
              ><v-icon class="ma-1">mdi mdi-pill-multiple</v-icon>
              รับยาที่โรงพยาบาล
            </span>
            <span
              class="w-400 text-navy-50 font-18 d-flex justify-end"
              v-if="itemHistory.pickup_location == 'home'"
            >
              <v-icon class="ma-1">mdi mdi-pill-multiple</v-icon> รับยาที่บ้าน
            </span>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col class="templateDetail" cols="12" xs="5" sm="5" md="5">
            <span class="pb-0 w-400 font-16 text-313B41">ชื่อ-นามสกุล</span>
          </v-col>
          <v-col
            class="templateDetail bobyPaddingBottom"
            cols="12"
            xs="7"
            sm="7"
            md="7"
          >
            <span class="pb-0 w-400 text-navy-50 font-16">
              :
              {{
                appointmentDetail.patient
                  ? appointmentDetail.patient.account_title_th
                  : ""
              }}
              {{ appointmentDetail.patient_name }}
            </span>
          </v-col>
          <v-col class="templateDetail" cols="12" xs="5" sm="5" md="5">
            <span class="pb-0 w-400 font-16 text-313B41">HN</span>
          </v-col>
          <v-col
            class="templateDetail bobyPaddingBottom"
            cols="12"
            xs="7"
            sm="7"
            md="7"
          >
            <span class="pb-0 w-400 text-navy-50 font-16"
              >:
              {{
                appointmentDetail.patient.HN
                  ? appointmentDetail.patient.HN
                  : "ไม่ระบุ"
              }}</span
            >
          </v-col>

          <v-col class="templateDetail" cols="12" xs="5" sm="5" md="5">
            <span class="pb-0 w-400 font-16 text-313B41">หมายเลขโทรศัพท์</span>
          </v-col>
          <v-col
            class="templateDetail bobyPaddingBottom"
            cols="12"
            xs="7"
            sm="7"
            md="7"
          >
            <span class="pb-0 w-400 text-navy-50 font-16"
              >:
              {{
                appointmentDetail.patient
                  ? appointmentDetail.patient.mobile
                  : "ไม่ระบุ"
              }}
            </span>
          </v-col>
          <v-col class="templateDetail" cols="12" xs="5" sm="5" md="5">
            <span class="pb-0 w-400 font-16 text-313B41">วันที่นัดหมาย</span>
          </v-col>
          <v-col
            class="templateDetail bobyPaddingBottom"
            cols="12"
            xs="7"
            sm="7"
            md="7"
          >
            <span class="pb-0 w-400 text-navy-50 font-16"
              >: {{ momentDate(appointmentDetail.date) }}</span
            >
          </v-col>
          <v-col class="templateDetail" cols="12" xs="5" sm="5" md="5">
            <span class="pb-0 w-400 font-16 text-313B41">เวลานัดหมาย</span>
          </v-col>
          <v-col
            class="templateDetail bobyPaddingBottom"
            cols="12"
            xs="7"
            sm="7"
            md="7"
          >
            <span class="pb-0 w-400 text-navy-50 font-16">
              : {{ appointmentDetail.start }} -
              {{ appointmentDetail.end }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="pa-0 ma-0"
      style="border: 1px solid #e5e5e5; border-radius: 10px"
      v-if="
        role_name !== 'แพทย์' &&
        appointmentDetail.status == 'finish' &&
        appointmentDetail.status_drug == 'pending' &&
        appointmentDetail.status_drug == 'confirm'
      "
    >
      <v-col cols="12" lg="12" class="d-flex flex-column mb-1">
        <div>
          <v-col cols="12" class="font-20 w-700 pb-2 pr-0 pl-0">
            <div v-if="itemHistory && itemHistory.drug_list.length !== 0">
              <v-row class="ma-0 pa-0">
                <v-col
                  class="d-flex pa-0 align-center"
                  style="border-bottom: 1px #313b41 solid"
                >
                  <span class="w-300 font-18 text-00A99D">สั่งยา</span>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0 mb-3"
                style="border-bottom: 1px #313b41 solid"
                v-if="itemHistory.drug_list.length >= 0"
              >
                <v-col class="pa-1" cols="1">
                  <span class="w-300 font-18 text-00A99D">#</span>
                </v-col>
                <v-col class="pa-1" cols="4">
                  <span class="w-300 font-18 text-00A99D">รายการยา</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">จำนวน</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">ราคา</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">ราคารวม </span>
                </v-col>
                <v-col class="pa-1" cols="1" align="center">
                  <span class="w-300 font-18 text-313B41"> </span>
                </v-col>
              </v-row>

              <v-row
                class="ma-0 pa-0"
                v-for="(item, index) in itemHistory.drug_list"
                :key="index"
              >
                <v-col class="pa-1" cols="1" align-self="center">
                  <span class="w-300 font-18 text-313B41">{{ index + 1 }}</span>
                </v-col>
                <v-col class="pa-1" cols="4">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="item.name_drug"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span
                    class="w-300 font-18 text-313B41"
                    v-if="check_biz == '668236676897760'"
                  >
                    <v-text-field
                      class="text-field"
                      v-model="item.quantity"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                      :min="0"
                    ></v-text-field>
                  </span>
                  <span class="w-300 font-18 text-313B41" v-else>
                    <v-text-field
                      class="text-field"
                      v-model="item.count"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                      :min="0"
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1 text-center" cols="2" align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="item.price"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center" text-align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="totalToFixed(item.total)"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="1" align="center" text-align="center">
                </v-col>

                <v-col class="pa-1" cols="1" align-self="center"></v-col>
                <v-col class="pa-1" cols="10" align-self="center">
                  <v-row class="usageAndAdvice">
                    <v-col
                      class="pa-1"
                      cols="12"
                      align-self="center"
                      style="white-space: wrap; text-overflow: ellipsis"
                    >
                      <span class="w-700 font-14 text-313B41">
                        ข้อมูลการใช้ยา :
                      </span>
                      <span class="w-300 font-14 text-313B41">
                        {{ item.usage || "-" }}
                      </span>
                    </v-col>
                    <v-col
                      class="pa-1"
                      cols="12"
                      align-self="center"
                      style="text-align: center"
                      v-if="item.advice"
                    >
                      <span class="w-700 font-12 text-EB5757">
                        ***
                        {{ item.advice }}
                        ***
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-col cols="12" class="d-flex justify-center">
                <span>สรุปยอดรายการยา {{ netprice(itemHistory) }} บาท</span>
              </v-col>
            </div>
            <div v-if="itemHistory && itemHistory.drug_list.length == 0">
              <v-row class="pa-0 ma-0">
                <v-col
                  cols="12"
                  class="noitems d-flex justify-center align-center text-center"
                >
                  <span class="font-18 w-700 text-00A99D">ไม่มีรายการยา</span>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </div>
      </v-col>
      <!-- สถานะจัดส่ง -->
      <v-col
        style="border-radius: 10px"
        class="d-flex justify-center"
        v-if="itemHistory && itemHistory.status_drug == 'confirm'"
      >
        <template v-if="role_name == 'แพทย์'">
          <v-col cols="7">
            <v-timeline>
              <!-- {{ itemHistory.telepharma_status }} -->
              <v-timeline-item
                :icon="
                  itemHistory.telepharma_status.send_patient_pickup_location
                    ? 'mdi-check-bold'
                    : ''
                "
                :color="
                  itemHistory.telepharma_status.send_patient_pickup_location ==
                    false ||
                  itemHistory.telepharma_status.send_patient_pickup_location ==
                    undefined
                    ? '#FFFFFF'
                    : itemHistory.telepharma_status
                        .send_patient_pickup_location == true
                    ? '#FAAD14'
                    : '#F5F5F5'
                "
                :fill-dot="
                  itemHistory.telepharma_status.send_patient_pickup_location ==
                    false ||
                  itemHistory.telepharma_status.send_patient_pickup_location ==
                    undefined
                    ? false
                    : itemHistory.telepharma_status
                        .send_patient_pickup_location == true
                    ? false
                    : true
                "
                class="pb-12"
              >
                <template v-slot:icon>
                  <img
                    v-if="
                      itemHistory.telepharma_status
                        .send_patient_pickup_location == true
                    "
                    :src="
                      require('@/assets/icon/Telepharma/prepare medicine.svg')
                    "
                  />
                  <v-icon v-else color="#FFFFFF">mdi-check-bold</v-icon>
                </template>

                <v-row>
                  <v-col cols="12">
                    <div class="d-flex flex-column">
                      <span
                        v-if="
                          itemHistory.telepharma_status
                            .send_patient_pickup_location == false ||
                          itemHistory.telepharma_status
                            .send_patient_pickup_location == undefined
                        "
                        class="text-333333 font-14 w-500"
                        >ส่งแบบสอบทามสถานที่รับยาแล้ว</span
                      >
                      <span v-else class="text-333333 font-14 w-700"
                        >ส่งแบบสอบทามสถานที่รับยาแล้ว</span
                      >
                      <span
                        v-if="
                          itemHistory.telepharma_status
                            .send_patient_pickup_location == false ||
                          itemHistory.telepharma_status
                            .send_patient_pickup_location == undefined
                        "
                        class="text-333333 font-14 w-400"
                        >-</span
                      >
                      <span v-else class="text-1CCE39 font-14 w-400"
                        >{{
                          momentDate(
                            itemHistory.telepharma_status
                              .send_patient_pickup_location_date
                          )
                        }}
                        เวลา
                        {{
                          momentTime(
                            itemHistory.telepharma_status
                              .send_patient_pickup_location_date
                          )
                        }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-timeline-item>
              <v-timeline-item
                :icon="
                  itemHistory.telepharma_status.patient_pickup_location
                    ? 'mdi-check-bold'
                    : ''
                "
                :color="
                  itemHistory.telepharma_status.patient_pickup_location ==
                    false ||
                  itemHistory.telepharma_status.patient_pickup_location ==
                    undefined
                    ? '#FFFFFF'
                    : itemHistory.telepharma_status.patient_pickup_location ==
                      true
                    ? '#FAAD14'
                    : '#F5F5F5'
                "
                :fill-dot="
                  itemHistory.telepharma_status.patient_pickup_location ==
                    false ||
                  itemHistory.telepharma_status.patient_pickup_location ==
                    undefined
                    ? false
                    : itemHistory.telepharma_status.patient_pickup_location ==
                      true
                    ? false
                    : true
                "
                class="pb-12"
              >
                <template v-slot:icon>
                  <img
                    v-if="
                      itemHistory.telepharma_status.length !== 0 ||
                      itemHistory.telepharma_status !== undefined
                    "
                    :src="
                      require('@/assets/icon/Telepharma/Find a driver (1).svg')
                    "
                  />
                  <v-icon v-else color="#FFFFFF">mdi-check-bold</v-icon>
                </template>
                <v-row>
                  <v-col cols="12">
                    <div class="d-flex flex-column">
                      <span
                        v-if="
                          itemHistory.telepharma_status
                            .patient_pickup_location == false ||
                          itemHistory.telepharma_status
                            .patient_pickup_location == undefined
                        "
                        class="text-333333 font-14 w-500"
                        >ผู้ป่วยเลือกสถานที่รับยาแล้ว
                        <!-- <v-btn @click="shows = !shows"> </v-btn>
                        <v-tooltip v-model="shows">
                          <span>Programmatic tooltip</span>
                        </v-tooltip> -->
                      </span>
                      <span v-else class="text-333333 font-14 w-700"
                        >ผู้ป่วยเลือกสถานที่รับยาแล้ว
                      </span>
                      <span
                        v-if="
                          itemHistory.telepharma_status
                            .patient_pickup_location == false ||
                          itemHistory.telepharma_status
                            .patient_pickup_location == undefined
                        "
                        class="text-333333 font-14 w-400"
                        >-</span
                      >
                      <span v-else class="text-1CCE39 font-14 w-400"
                        >{{
                          momentDate(
                            itemHistory.telepharma_status
                              .patient_pickup_location_date
                          )
                        }}
                        เวลา
                        {{
                          momentTime(
                            itemHistory.telepharma_status
                              .patient_pickup_location_date
                          )
                        }}</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-timeline-item>
              <v-timeline-item
                :icon="
                  itemHistory.telepharma_status.register_formdrug
                    ? 'mdi-check-bold'
                    : ''
                "
                :color="
                  itemHistory.telepharma_status.register_formdrug == false ||
                  itemHistory.telepharma_status.register_formdrug == undefined
                    ? '#FFFFFF'
                    : itemHistory.telepharma_status.register_formdrug == true
                    ? '#FAAD14'
                    : '#F5F5F5'
                "
                :fill-dot="
                  itemHistory.telepharma_status.register_formdrug == false ||
                  itemHistory.telepharma_status.register_formdrug == undefined
                    ? false
                    : itemHistory.telepharma_status.register_formdrug == true
                    ? false
                    : true
                "
                class="pb-12"
              >
                <template v-slot:icon>
                  <img
                    v-if="
                      itemHistory.telepharma_status.length !== 0 ||
                      itemHistory.telepharma_status !== undefined
                    "
                    :src="require('@/assets/icon/Telepharma/driver (1).svg')"
                  />
                  <v-icon v-else color="#FFFFFF">mdi-check-bold</v-icon>
                </template>
                <v-row>
                  <v-col cols="12">
                    <div class="d-flex flex-column">
                      <span
                        v-if="
                          itemHistory.telepharma_status.register_formdrug ==
                            false ||
                          itemHistory.telepharma_status.register_formdrug ==
                            undefined
                        "
                        class="text-333333 font-14 w-500"
                        >เจ้าหน้าที่ตรวจสอบแล้ว อยู่ระหว่างการจัดส่ง</span
                      >
                      <span v-else class="text-333333 font-14 w-700"
                        >เจ้าหน้าที่ตรวจสอบแล้ว อยู่ระหว่างการจัดส่ง</span
                      >
                      <span
                        v-if="
                          itemHistory.telepharma_status.register_formdrug ==
                            false ||
                          itemHistory.telepharma_status.register_formdrug ==
                            undefined
                        "
                        class="text-333333 font-14 w-400"
                        >-</span
                      >
                      <span v-else class="text-1CCE39 font-14 w-400"
                        >{{
                          momentDate(
                            itemHistory.telepharma_status.register_formdrug_date
                          )
                        }}
                        เวลา
                        {{
                          momentTime(
                            itemHistory.telepharma_status.register_formdrug_date
                          )
                        }}</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-timeline-item>
              <v-timeline-item
                :icon="
                  itemHistory.telepharma_status.transport
                    ? 'mdi-check-bold'
                    : ''
                "
                :color="
                  itemHistory.telepharma_status.transport == false ||
                  itemHistory.telepharma_status.transport == undefined
                    ? '#FFFFFF'
                    : itemHistory.telepharma_status.transport == true
                    ? '#FAAD14'
                    : '#F5F5F5'
                "
                :fill-dot="
                  itemHistory.telepharma_status.transport == false ||
                  itemHistory.telepharma_status.transport == undefined
                    ? false
                    : itemHistory.telepharma_status.transport == true
                    ? false
                    : true
                "
                class="pb-12"
              >
                <template v-slot:icon>
                  <img
                    v-if="
                      itemHistory.telepharma_status.length !== 0 ||
                      itemHistory.telepharma_status !== undefined
                    "
                    :src="require('@/assets/icon/Telepharma/finish (1).svg')"
                  />
                  <v-icon v-else color="#FFFFFF">mdi-check-bold</v-icon>
                </template>
                <v-row>
                  <v-col cols="12">
                    <div class="d-flex flex-column">
                      <span
                        v-if="
                          itemHistory.telepharma_status.transport == false ||
                          itemHistory.telepharma_status.transport == undefined
                        "
                        class="text-333333 font-14 w-500"
                        >จัดส่งรายการยาสำเร็จแล้ว</span
                      >
                      <span v-else class="text-333333 font-14 w-700"
                        >จัดส่งรายการยาสำเร็จแล้ว</span
                      >
                      <span
                        v-if="
                          itemHistory.telepharma_status.transport == false ||
                          itemHistory.telepharma_status.transport == undefined
                        "
                        class="text-333333 font-14 w-400"
                        >-</span
                      >
                      <span v-else class="text-1CCE39 font-14 w-400"
                        >{{
                          momentDate(
                            itemHistory.telepharma_status.transport_date
                          )
                        }}
                        เวลา
                        {{
                          momentTime(
                            itemHistory.telepharma_status.transport_date
                          )
                        }}</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </template>

        <!-- สถานะจัดส่ง -->
      </v-col>
    </v-row>
    <v-row
      class="pa-0 ma-0"
      style="border: 1px solid #e5e5e5; border-radius: 10px"
      v-if="role_name === 'แพทย์' && appointmentDetail.status_drug == 'return'"
    >
      <v-col cols="12" lg="12" class="d-flex flex-column mb-1">
        <div>
          <v-col cols="12" class="font-20 w-700 pb-2 pr-0 pl-0">
            <div v-if="itemHistory && itemHistory.drug_list.length !== 0">
              <v-row class="ma-0 pa-0">
                <v-col
                  class="d-flex pa-0 align-center"
                  style="border-bottom: 1px #313b41 solid"
                >
                  <span class="w-300 font-18 text-00A99D">สั่งยา</span>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0 mb-3"
                style="border-bottom: 1px #313b41 solid"
                v-if="itemHistory.drug_list.length >= 0"
              >
                <v-col class="pa-1" cols="1">
                  <span class="w-300 font-18 text-00A99D">#</span>
                </v-col>
                <v-col class="pa-1" cols="4">
                  <span class="w-300 font-18 text-00A99D">รายการยา</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">จำนวน</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">ราคา</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">ราคารวม </span>
                </v-col>
                <v-col class="pa-1" cols="1" align="center">
                  <span class="w-300 font-18 text-313B41"> </span>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col cols="12">
                  <span class="w-700 font-18 text-313B41">รายการยาเดิม </span>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0"
                v-for="(item, index) in itemHistory.drug_list"
                :key="index"
              >
                <v-col class="pa-1" cols="1" align-self="center">
                  <span class="w-300 font-18 text-313B41">{{ index + 1 }}</span>
                </v-col>
                <v-col class="pa-1" cols="4">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="item.name_drug"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      v-model="item.count"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                      :min="0"
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1 text-center" cols="2" align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="item.price"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center" text-align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="totalToFixed(item.total)"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col class="pa-1" cols="1" text-align="center"></v-col>
                <v-col v-if="itemHistory.status_drug == 'return'" class="pa-1" cols="10" text-align="center"
                  ><span
                    class="w-300 font-18 text-313B41"
                    v-if="
                      itemHistory.note !== '' || itemHistory.note !== undefined
                    "
                    >หมายเหตุ:
                    {{ itemHistory.note }}
                  </span>
                  <span class="w-300 font-18 text-313B41" v-else
                    >หมายเหตุ: ไม่ระบุ
                  </span></v-col
                >
                <v-col class="pa-1" cols="12" align="right" text-align="center">
                  <span class="w-300 font-18 text-313B41"
                    >สรุปยอดรายการยา {{ netprice(itemHistory) }} บาท</span
                  >
                </v-col>
              </v-row>
            </div>
            <div
              v-if="
                itemHistory &&
                itemHistory.drug_list.length == 0 &&
                itemHistory.status_drug == 'return'
              "
            >
              <v-row class="pa-0 ma-0 pb-2">
                <v-col
                  cols="12"
                  class="noitems_return d-flex justify-center align-center text-center"
                >
                  <span class="font-18 w-700 text-00A99D">ไม่มีรายการยา</span>
                </v-col>
              </v-row>
            </div>
            <div v-else-if="itemHistory && itemHistory.drug_list.length == 0">
              <v-row class="pa-0 ma-0 pb-2">
                <v-col
                  cols="12"
                  class="noitems d-flex justify-center align-center text-center"
                >
                  <span class="font-18 w-700 text-00A99D">ไม่มีรายการยา</span>
                </v-col>
              </v-row>
            </div>

            <div>
              <v-divider></v-divider>
              <v-row class="ma-0 pa-0">
                <v-col cols="12">
                  <span class="w-700 font-18 text-313B41"
                    >รายการยาที่ต้องการเเก้ไข
                  </span>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0"
                v-for="(drug_edit_item, index) in itemDrug_new"
                :key="`edit-${index}`"
              >
                <v-col class="pa-1" cols="1" align-self="center">
                  <span class="w-300 font-18 text-313B41">{{ index + 1 }}</span>
                </v-col>
                <v-col class="pa-1" cols="4">
                  <span class="w-300 font-18 text-313B41">
                    <v-autocomplete
                      class="text-field"
                      outlined
                      small
                      hide-details="auto"
                      dense
                      :items="itemSearchDrug"
                      @keyup.passive="searchDrugList"
                      @input="(e) => setDrug(e, index, 'list')"
                      return-object
                      item-text="name_drug"
                      item-value="_id"
                      placeholder="กรอกรายการยา"
                    ></v-autocomplete>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <v-text-field
                    class="w-300 font-18 text-313B41"
                    type="number"
                    hide-details="auto"
                    dense
                    outlined
                    small
                    @input="(e) => setDrug(e, index, 'count')"
                    v-model="itemDrug_new[index].count"
                    placeholder="กรอกจำนวน"
                    :min="0"
                    :max="CheckQuantity(itemDrug_new[index])"
                    oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
                    :rules="[
                      (v) =>
                        (v >= 0 && v <= CheckQuantity(itemDrug_new[index])) ||
                        'ยาไม่พอ',
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col class="pa-1 text-center" cols="2" align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      outlined
                      hide-details
                      dense
                      v-model="itemDrug_new[index].sum"
                      small
                      readonly
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center" text-align="center">
                  <div class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="priceTakingMedicine(itemDrug_new[index])"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col class="pa-1" cols="1" align="center" text-align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-icon color="red" @click="delDrug(index)">
                      mdi-trash-can-outline</v-icon
                    >
                  </span>
                </v-col>

                <v-col class="pa-1" cols="1" align-self="center"></v-col>
                <v-col class="pa-1" cols="10" align-self="center">
                  <v-row class="usageAndAdvice" v-show="show">
                    <v-col
                      class="pa-1"
                      cols="12"
                      align-self="center"
                      style="white-space: wrap; text-overflow: ellipsis"
                    >
                      <span class="w-700 font-14 text-313B41">
                        จำนวนยาในคลัง :
                      </span>
                      <span class="w-300 font-14 text-313B41"
                        >{{ itemDrug_new[index].list_drug.quantity }}
                      </span>
                      <span class="w-300 font-14 text-313B41">
                        {{ itemDrug_new[index].list_drug.unit }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-col class="pa-1" cols="1" align-self="center"></v-col>
                  <v-row class="usageAndAdvice" v-show="show">
                    <v-col
                      class="pa-1"
                      cols="12"
                      align-self="center"
                      style="white-space: wrap; text-overflow: ellipsis"
                    >
                      <span class="w-700 font-14 text-313B41">
                        ข้อมูลการใช้ยา :
                      </span>
                      <span class="w-300 font-14 text-313B41"
                        >{{
                          itemDrug_new[index].list_drug.usage
                            ? itemDrug_new[index].list_drug.usage
                            : "-"
                        }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-col cols="12" lg="12" class="text-right">
                <v-btn icon @click="addDrug">
                  <v-icon color="#00a99d">mdi-plus-circle</v-icon>
                </v-btn>
              </v-col>
              <v-row class="pl-2 pr-2 pt-3 d-flex justify-center">
                <v-col class="pa-1" cols="5">
                  <span class="w-300 font-18 text-313B41"
                    >สรุปรายการยา {{ quantity(itemDrug_new) }} รายการ</span
                  >
                </v-col>
                <v-col class="pa-1" cols="5" align="end">
                  <span class="w-300 font-18 text-313B41">ราคารวม </span>
                  <span class="w-300 font-18 text-3D85E1">
                    {{ sumPrice(itemDrug_new) }}
                  </span>
                  <span class="w-300 font-18 text-313B41"> บาท</span>
                </v-col>
                <v-col class="ma-0 pa-0 pt-3" style="text-align: center">
                  <v-btn
                    color="#336bb4"
                    dark
                    class="ml-auto"
                    v-show="!canedit"
                    @click="OrderDrugRecord()"
                  >
                    บันทึกการสั่งยา
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </div>
      </v-col>
    </v-row>
    <v-row
      class="pa-0 ma-0"
      style="border: 1px solid #e5e5e5; border-radius: 10px"
      v-else
    >
      <v-col cols="12" lg="12" class="d-flex flex-column mb-1">
        <div>
          <v-col cols="12" class="font-20 w-700 pb-2 pr-0 pl-0">
            <div v-if="itemHistory && itemHistory.drug_list.length !== 0">
              <v-row class="ma-0 pa-0">
                <v-col
                  class="d-flex pa-0 align-center"
                  style="border-bottom: 1px #313b41 solid"
                >
                  <span class="w-300 font-18 text-00A99D">สั่งยา</span>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0 mb-3"
                style="border-bottom: 1px #313b41 solid"
                v-if="itemHistory.drug_list.length >= 0"
              >
                <v-col class="pa-1" cols="1">
                  <span class="w-300 font-18 text-00A99D">#</span>
                </v-col>
                <v-col class="pa-1" cols="4">
                  <span class="w-300 font-18 text-00A99D">รายการยา</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">จำนวน</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">ราคา</span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span class="w-300 font-18 text-00A99D">ราคารวม </span>
                </v-col>
                <v-col class="pa-1" cols="1" align="center">
                  <span class="w-300 font-18 text-313B41"> </span>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col cols="12">
                  <span class="w-700 font-18 text-313B41">รายการยา </span>
                </v-col>
              </v-row>
              <v-row
                class="ma-0 pa-0"
                v-for="(item, index) in itemHistory.drug_list"
                :key="index"
              >
                <v-col class="pa-1" cols="1" align-self="center">
                  <span class="w-300 font-18 text-313B41">{{ index + 1 }}</span>
                </v-col>
                <v-col class="pa-1" cols="4">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="item.name_drug"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center">
                  <span
                    class="w-300 font-18 text-313B41"
                    v-if="check_biz == '668236676897760'"
                  >
                    <v-text-field
                      class="text-field"
                      v-model="item.quantity"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                      :min="0"
                    ></v-text-field>
                  </span>
                  <span class="w-300 font-18 text-313B41" v-else>
                    <v-text-field
                      class="text-field"
                      v-model="item.count"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                      :min="0"
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1 text-center" cols="2" align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="item.price"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col class="pa-1" cols="2" align="center" text-align="center">
                  <span class="w-300 font-18 text-313B41">
                    <v-text-field
                      class="text-field"
                      :value="totalToFixed(item.total)"
                      outlined
                      dense
                      small
                      readonly
                      hide-details
                    ></v-text-field>
                  </span>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col class="pa-1" cols="1" text-align="center"></v-col>
                <v-col v-if="itemHistory.status_drug == 'return'" class="pa-1" cols="10" text-align="center"
                  ><span
                    class="w-300 font-18 text-313B41"
                    v-if="
                      itemHistory.note !== '' || itemHistory.note !== undefined
                    "
                    >หมายเหตุ:
                    {{ itemHistory.note }}
                  </span>
                  <span class="w-300 font-18 text-313B41" v-else
                    >หมายเหตุ: ไม่ระบุ
                  </span></v-col
                >
                <v-col cols="12" class="d-flex justify-center">
                  <span>สรุปยอดรายการยา {{ netprice(itemHistory) }} บาท</span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
            <div v-if="itemHistory.drug_list.length == 0">
              <v-row class="pa-0 ma-0">
                <v-col
                  cols="12"
                  class="noitems d-flex justify-center align-center text-center"
                >
                  <span class="font-32 w-700">ไม่มีข้อมูลรายการยา</span>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      // itemDrug: [],
      selectDrug: true,
      medical_record: "",
      shows: false,
      show: false,
      itemDrug_new: [{ list_drug: {}, price: "", count: "", sum: "" }],
      itemSearchDrug: [],
      item_data: {},
      selectedItem: "",
      canedit: false,
      windowWidth: window.innerWidth,
      medicineList: [],
      check_biz: sessionStorage.biz_id,
      role_name: sessionStorage.role_name,
      itemHistoryCalling: [],
      // itemHistory: [],
      showCurrent: null,
      selectPatient: {},
      // total: 0,
      page: 1,
      totalCalling: 0,
      pageCalling: 1,
    };
  },
  props: {
    reset: { type: Boolean, default: true },
  },
  watch: {
    reset() {
      //   this.reset_data();
    },
    itemHistory() {
      this.itemDrug_new = [{ list_drug: {}, price: "", count: "", sum: "" }];
    },
  },

  mounted() {
    this.searchDrugList()
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    // this.getDrugList();
  },

  created() {
    // this.getHistory();
  },

  destroyed() {},

  beforeDestroy() {
    this.$store.dispatch("windowWidthAction", this.windowWidth);
  },
  computed: {
    ...mapState(["itemDrug", "itemHistory", "total", "appointmentDetail"]),
    ...mapGetters({
      getHealth: "getHealthInfoGetter" || {},
      getQueueDrug: "getQueueDrugGatter" || {},
      view: "viewHistoryTalkingGetter" || {},
      currentPatient: "currentPatientGetter" || {},
    }),
  },
  methods: {
    addDrug() {
      this.itemDrug_new.push({ list_drug: {}, price: "", count: "", sum: "" });
    },

    quantity(itemDrug) {
      let quantity = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "") {
          quantity++;
        }
      });
      return quantity;
    },

    sumPrice(itemDrug) {
      let netprice = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "" && ele.count !== "") {
          netprice += Number(ele.count) * Number(ele.price);
        }
      });
      return netprice.toFixed(2);
    },

    CheckQuantity(item) {
      if (
        item &&
        "list_drug" in item &&
        "quantity" in item.list_drug &&
        item.list_drug.quantity
      ) {
        return item.list_drug.quantity;
      } else {
        return 0;
      }
    },
    priceTakingMedicine(item) {
      let price = 0;
      if (item.count !== "") {
        price = item.count * item.price;
      }
      return price.toFixed(2);
    },
    async searchDrugList(search) {
      try {
        let word = "";
        if (search !== undefined) {
          if (search.target.value.length !== 0) {
            word = search.target.value;
          }
        }
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("search", word || "");

        const { data: { data } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/druglists/search?${params}`
        );
        if (data[0]) {
          const { data: dataSearch = {} } = data[0];
          this.itemSearchDrug = dataSearch;
          console.log(
            "🚀 ~ file: Tab3DrugRecords.vue:115 ~ searchDrugList ~ dataSearch:",
            dataSearch
          );
        }
        // if (result == "success") {

        // }

        // console.log("🚀 ~ file: Drug.vue:99 ~ getDrugList ~ data:", data);
      } catch (error) {
        console.error();
      }
    },
    setDrug(event, index, type) {
      console.log("event", event);
      console.log("index", index);
      console.log("type", type);

      switch (type) {
        case "count":
          console.log("event", event);
          if (event != 0) {
            this.itemDrug_new[index].sum = parseFloat(
              parseFloat(this.itemDrug_new[index].price) * parseInt(event)
            );
          } else {
            this.itemDrug_new[index].sum = 0;
          }

          break;
        case "list":
          this.itemDrug_new[index].list_drug = event;
          this.itemDrug_new[index].count = 1;
          this.itemDrug_new[index].price = event.price;
          this.itemDrug_new[index].sum = event.price;
          this.show = true;
          break;
        case "price":
          this.itemDrug_new[index].price = event.price;
          break;
        default:
          break;
      }
    },
    delDrug(index) {
      if (index > -1) {
        // only splice array when item is found
        if (this.itemDrug_new.length == 1) {
          this.itemDrug_new = [
            { list_drug: {}, price: "", count: "", sum: "" },
          ];
        } else {
          this.itemDrug_new.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
    },
    async OrderDrugRecord() {
      let drug_list = [];
      console.log("this.itemDrug_new", this.itemDrug_new);
      this.itemDrug_new.forEach((element) => {
        if (element.price != "" && element.count != "" && element.count != 0) {
          drug_list.push({
            ...element.list_drug,
            total: element.sum,
            count: element.count,
          });
        }
      });
      if (drug_list.length == 0) {
        Swal.fire({
          type: "error",
          position: "center",
          icon: "error",
          showConfirmButton: false,
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>กรุณากรอกรายการยา</span>",
          timer: 1500,
        });
      } else {
        const data = {
          status_drug: "pending",
          drug_list: drug_list,
          appointment_id: this.appointmentDetail.appointment_id,
        };
        this.axios
          .put(`${process.env.VUE_APP_BACKEND_URL}/v1/drug-status`, data)
          .then((res) => {
            if (res.data.result === "success") {
              Swal.fire({
                type: "success",
                position: "center",
                icon: "success",
                showConfirmButton: false,
                title:
                  "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
                timer: 1500,
              });
              this.$emit("update");
            }
          })
          .catch((error) => {
            console.log("error", error);
            Swal.fire({
              type: "error",
              position: "center",
              icon: "error",
              showConfirmButton: false,
              title:
                "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
              timer: 1500,
            });
          });
      }
    },
    // changeSelect(e) {
    //   if (e) this.showCurrent = this.itemHistory.find((obj) => obj._id === e);
    //   else this.showCurrent = null;
    //   console.log(this.showCurrent);
    // },
    // async getHistory() {
    //   try {
    //     const params = new URLSearchParams();
    //     params.append("page", this.page || 1);
    //     params.append("limit", 10);
    //     // params.append("biz_id", sessionStorage.biz_id);
    //     params.append("search", this.detailQueue[0].patient_id);

    //     const { data: { data, result } = {} } = await this.axios.get(
    //       `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories/patient?${params}`
    //     );

    //     if (result == "success") {
    //       if (data[0]) {
    //         this.itemDrug = [];
    //         const { data: searchData, metadata } = data[0];
    //         const { total } = metadata[0];
    //         this.total = total;
    //         this.itemHistory = searchData;
    //         searchData.forEach((element) => {
    //           this.itemDrug.push({ id: element._id, drug: element.drug_list });
    //         });
    //       }
    //       console.log(
    //         "itemHistory////////////////////////////",
    //         this.itemHistory
    //       );
    //     }
    //   } catch (error) {
    //     console.error();
    //   }
    // },
    momentDate(date) {
      // console.log(date_diagnotic);
      var year1 = moment(date).locale("th").format("YYYY");
      var year2 = (parseInt(year1) + 543).toString();
      return moment(date)
        .locale("th")
        .format("DD MMMM " + year2);
    },
    momentTime(date) {
      return moment(date).locale("th").add(543, "year").format("HH:mm");
    },
    sum(index) {
      console.log();
      if (this.itemHistory[index].drug_list) {
        return this.itemHistory[index].drug_list.reduce(
          (total, drug) => total + drug.total,
          0
        );
      }
      return "";
    },
    netprice(itemHistory) {
      let netprice = 0;
      if (this.check_biz == "668236676897760") {
        if (itemHistory) {
          itemHistory.drug_list.forEach((ele) => {
            if (ele.price !== "" && ele.quantity !== "") {
              netprice += Number(ele.quantity) * Number(ele.price);
            }
          });
          return netprice.toFixed(2);
        }
      } else {
        if (itemHistory) {
          itemHistory.drug_list.forEach((ele) => {
            if (ele.price !== "" && ele.count !== "") {
              netprice += Number(ele.count) * Number(ele.price);
            }
          });
          return netprice.toFixed(2);
        }
      }
    },
    totalToFixed(item) {
      if (item) {
        return item.toFixed(2);
      }
      return null;
    },
    displayDate(date) {
      if (!date) return "-";
      return moment(date)
        .locale("th")
        .add(543, "years")
        .format("DD MMMM YYYY HH:mm น.");
    },
    displayBirthDate(date) {
      if (!date) return "-";
      return moment(date).locale("th").add(543, "years").format("DD MMMM YYYY");
    },
    changePage(e) {
      this.page = e;
      // this.getHistory();
    },
    changePageCalling(e) {
      // console.log(e, this.pageCalling);
      this.pageCalling = e;
      this.getHistoryCalling();
    },
    showData(item, index) {
      if (item[index].id == this.selectedItem) {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.left-content {
  width: 45%;
}
.right-content {
  width: 55%;
  // height: 100vh;
  margin-top: -12px;
  // margin-bottom: -12px;
  // border-left: 1px solid #babdbf;
}
.v-list-item-group .v-list-item--active {
  color: #fff;
  background: #00a99d;
}
.v-list-item {
  background: rgba(239, 246, 252, 0.6);
  color: #000;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.noitems {
  height: 72vh;
  border: 1px solid #e8e9e9;
  border-radius: 10px;
}
.noitems_return {
  height: 28vh;
  border: 1px solid #e8e9e9;
  border-radius: 10px;
}

.usageAndAdvice {
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  margin: 0px;
}
::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: rgb(0 0 0);
}
</style>
